// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] button[type=button][data-v-076ce1cd]{background-color:#00cfe8}", ""]);
// Exports
module.exports = exports;
